import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useCurrentConfigData from '../dashboardLoading/useCurrentConfig';

const useTopTier = () => {
    const request = useHttps();
    const { getCurrentConfigData } = useCurrentConfigData();
    const [loading, setLoading] = useState(false);

    const onGetTopTierError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while setting top tier.',
        );
    };

    const onGetTopTierSuccess = (callbackFn: () => void) => ({ data, message }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Top tier added successfully.');
        callbackFn();
        getCurrentConfigData();
    };

    const setTopTier = (data: any, callbackFn: () => void) => {
        const url: HttpConfig = {
            url: `ba/v1/configs/set-tier-threshold`,
            method: 'post',
            data
        };

        request(url, onGetTopTierSuccess(callbackFn), setLoading, onGetTopTierError);
    };

    return { setTopTier, loading };
};

export default useTopTier;
